export default {"src":"/_next/static/media/safety-security-section.gif.cd1ac2f9.webp","height":700,"width":700,"blurWidth":0,"blurHeight":0};